<template>
  <div>
    <el-input
      ref="main"
      :placeholder="$t(placeholder)"
      v-model="showValue"
      :size="size"
      :clearable="disabled ? false : clearable"
      :disabled="disabled"
      @clear="handleInputClear"
      @focus="handleShow"
    >
      <template #append>
        <span v-if="!disabled" @click="handleShow">
          <el-button slot="append" icon="el-icon-more"></el-button>
        </span>
      </template>
    </el-input>
    <l-dialog
      :title="$t(placeholder)"
      :visible.sync="dialogVisible"
      :height="height"
      :width="width"
      :hasBtns="multiple"
      @ok="handleSelectMultiple"
      @opened="handleDialogOpened"
    >
      <l-layout class="l-tab-page">
        <l-select-panel
          :showQueryMorePanel="showQueryMorePanel"
          :queryItems="queryItems"
          :queryData="queryData"
          v-model="value2"
          :isChangeSearch="isChangeSearch"
          ref="selectPanel"
          :valueKey="valueKey"
          model="client"
          :columns="myColumns"
          :selectedData.sync="selectedData"
          :multiple="multiple"
          :isPage="isPage"
          :loadSelectTable="loadSelectTable"
          @rowClick="handleSelectPanel"
          style="padding: 8px"
          :memoryColWidth="memoryColWidth"
        >
        </l-select-panel>
      </l-layout>
    </l-dialog>
  </div>
</template>
<script>
export default {
  name: "l-layer-select",
  props: {
    // wuhb
    showQueryMorePanel: {
      //显示更多查询条件面板
      type: Boolean,
      default: false,
    },
    isChangeSearch: {
      type: Boolean,
      default: true,
    },
    queryData: {
      //查询数据
      type: Object,
      default: null,
    },
    queryItems: {
      //查询项列表
      type: Array,
      default: () => [],
    },

    value: {},
    placeholder: {
      type: String,
      default: "请选择",
    },
    size: {
      type: String,
      default: "mini",
    },
    clearable: {
      type: Boolean,
      default: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    height: {
      type: Number,
      default: 504,
    },
    width: {
      type: Number,
      default: 960,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    //显示时查询的数据
    options_Search: {
      type: Array,
      default: () => [],
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },

    isPage: {
      type: Boolean,
      default: true,
    },
    isApi: {
      type: Boolean,
      default: false,
    },
    code: String,

    disabled: {
      type: Boolean,
      default: false,
    },
    param: {
      type: String,
      default: "",
    },
    memoryColWidth: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      selectedData: [],
      value2: "",
    };
  },
  computed: {
    showValue: {
      get() {
        if (this.$validatenull(this.value)) {
          return "";
        }

        if (this.isPage && this.isApi && this.lr_loadDataSourcePage) {
          this.lr_loadDataSourceDataByValue(
            this.code,
            this.valueKey,
            this.value,
            this.param //wuhb:增加param参数
          );
        }

        const value = this.value + "";
        const valueList = value.split(",");
        const res = [];
        valueList.forEach((item) => {
          let v;
          if (this.isPage && this.isApi && this.lr_loadDataSourcePage) {
            v = this.lr_dataSourceDataByValue[`${this.code}_${item}`];
          } else {
            v = this.options.find((t) => t[this.valueKey] == item);
            //在原有数据基础上查询不到的，去另一个数据源中查询
            if (!v && this.options_Search.length > 0) {
              v = this.options_Search.find((t) => t[this.valueKey] == item);
            }
          }
          if (v) {
            res.push(v[this.labelKey]);
          } else {
            res.push(item); // 如果找不到值就显示原值
          }
        });
        return String(res);
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    myColumns() {
      return this.columns.filter((t) => !t.hidden);
    },
    /*myOptions(){
      return this.options.map((t,index)=>({...t,learun_value:index + ''}))
    },*/
  },
  mounted() {},
  watch: {
    value: {
      handler(val) {
        //const valueList = this.myOptions.filter(t=>t.)
        this.value2 = val;
      },
      immediate: true,
    },
    options: {
      handler() {
        this.$refs.selectPanel && this.$refs.selectPanel.init();
      },
    },
  },
  methods: {
    handleInputClear() {
      this.$refs.selectPanel.handleClear();
      this.handleChange();
    },
    handleChange(val) {
      this.$emit("change", val);
    },
    handleShow() {
      if (!this.disabled) {
        this.dialogVisible = true;
      }
    },

    tableLoadData() {
      this.$refs.selectPanel.init();
    },
    addZero: function addZero(time) {
      if (time >= 1 && time <= 9) {
        time = "0" + time;
      }
      return time;
    },
    addDays: function addDays(datestr, days) {
      //datestr为yyyy-MM-dd格式的时间字符串;days为天数
      var strArray = datestr.split("-");
      const date = {
        year: strArray[0],
        month: strArray[1],
        date: strArray[2],
      };
      var nDate = new Date(date.month + "-" + date.date + "-" + date.year); //转换为MM-DD-YYYY格式
      //兼容火狐时间戳
      if (nDate == "Invalid Date") {
        nDate = new Date(date.month + "/" + date.date + "/" + date.year);
      }
      var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
      var rDate = new Date(millSeconds);
      var year = rDate.getFullYear();
      var month = rDate.getMonth() + 1;
      month = this.addZero(month);
      var date1 = rDate.getDate();
      date1 = this.addZero(date1);
      return year + "-" + month + "-" + date1;
    },
    loadSelectTable(postData) {
      if (this.isPage && this.isApi && this.lr_loadDataSourcePage) {
        let whereSql = "";
        //wuhb:查询面板里的查询条件
        this.queryItems &&
          this.queryItems.forEach((item) => {
            if (this.queryData && this.queryData[item.prop]) {
              if (whereSql) {
                whereSql += " AND ";
              }

              if (item.type == "text") {
                whereSql += ""
                  .concat(item.prop, " like '%")
                  .concat(this.queryData[item.prop], "%'");
              } else if (item.type == "daterange") {
                const dateList = this.queryData[item.prop].split(" - ");
                whereSql += ""
                  .concat(item.prop, " >='")
                  .concat(dateList[0], " 00:00:00'");
                whereSql += " AND "
                  .concat(item.prop, " <='")
                  .concat(dateList[1], " 00:00:00'");
              } else if (item.type == "date") {
                //查询当前选择的日期
                console.log(this.queryData[item.prop]);
                const dateList = this.queryData[item.prop].split(" - ");
                whereSql += ""
                  .concat(item.prop, " >='")
                  .concat(dateList[0], " 00:00:00'");
                whereSql += " AND "
                  .concat(item.prop, " <'")
                  .concat(this.addDays(dateList[0], 1), " 00:00:00'");
              } else if (item.type == "select" || item.type == "radiogroup") {
                whereSql += ""
                  .concat(item.prop, " ='")
                  .concat(this.queryData[item.prop], "'");
              } else if (item.type == "checkboxgroup") {
                var valArray = this.queryData[item.prop].split(",");
                var strValue = "";
                valArray.forEach((item, index) => {
                  if (item) {
                    if (strValue) {
                      strValue += ",";
                    }
                    strValue += "'" + item + "'";
                  }
                });
                if (strValue) {
                  whereSql += ""
                    .concat(item.prop, " in(")
                    .concat(strValue, ")");
                }
              }
            }
          });

        if (postData.keyword) {
          for (const col of this.myColumns) {
            if (whereSql) {
              whereSql += " OR ";
            }
            whereSql += `${col.prop} like '%${postData.keyword}%'`;
          }
        }

        return this.lr_loadDataSourcePage(this.code, {
          page: postData.page,
          rows: postData.rows,
          sidx: this.myColumns[0].prop,
          whereSql: whereSql,
          param: this.param ? this.param : "",
        });
      } else {
        return new Promise((resolve) => {
          if (this.options.length == 0) {
            resolve({ rows: [] });
          } else {
            const data = this.options.filter((t) => {
              let res = false;
              for (const col of this.myColumns) {
                const item = (t[col.prop] || "") + "";
                if (
                  item.toLowerCase().indexOf(postData.keyword.toLowerCase()) !=
                  -1
                ) {
                  res = true;
                  break;
                }
              }
              return res;
            });
            const filterData = data.filter((item) => {
              if (this.queryData && Object.keys(this.queryData).length) {
                return Object.keys(this.queryData).every((key) => {
                  const qVal = this.queryData[key];
                  if (qVal === "") return true;
                  const iVal = item[key];
                  return String(iVal).includes(String(qVal));
                });
              }
              return true;
            });
            if (this.isPage) {
              const rows = this.$pagination(
                postData.page,
                postData.rows,
                filterData
              );
              resolve({ rows: rows, records: filterData.length });
            } else {
              resolve({ rows: filterData });
            }
          }
        });
      }
    },

    handleDialogOpened() {
      this.tableLoadData();
    },
    handleSelectPanel(row) {
      this.$emit("input", this.value2);
      this.$refs.main.focus();
      this.$refs.main.blur();
      this.dialogVisible = false;

      this.handleChange(row);
    },
    handleSelectMultiple() {
      this.$emit("input", this.value2);
      this.$refs.main.focus();
      this.$refs.main.blur();
      this.dialogVisible = false;
      this.handleChange(this.selectedData);
    },
  },
};
</script>
